import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ViolationService } from '../violation-service/violation.service';
import { data } from 'jquery';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-violations-set-form',
  templateUrl: './violations-set-form.component.html',
  styleUrls: ['./violations-set-form.component.css']
})
export class ViolationsSetFormComponent implements OnInit {
  violationForm: FormGroup;
  // violationId;

  constructor(
    private violatioServie: ViolationService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.violationForm = this.fb.group({
      batch: this.fb.group({
        pickupEarly: ["0", Validators.required],
        pickupWait: ["0", Validators.required],
        pickupLate: ["0", Validators.required],
        dropoffEarly: ["0", Validators.required],
        dropoffWait: ["0", Validators.required],
        dropoffLate: ["0", Validators.required],
        returnPickupEarly: ["0", Validators.required],
        returnPickupWait: ["0", Validators.required],
        returnPickupLate: ["0", Validators.required],
        maxOnBoardTime: ["0", Validators.required],
        breakCushion: [0, Validators.required],
        groupCushion: [0, Validators.required],
        groupRadius: [0, Validators.required],
        maxDistancePerRun: ["0", Validators.required],
        maxPerRun: ["0", Validators.required],
        overlapIndication: ["0", Validators.required],
        isOnboardViolation: [false, Validators.required],
        isCapacityViolation: [false, Validators.required],
        prefferedToSameDriver: [false, Validators.required],
      }),
      single: this.fb.group({
        pickupEarly: ["0", Validators.required],
        pickupWait: ["0", Validators.required],
        pickupLate: ["0", Validators.required],
        dropoffEarly: ["0", Validators.required],
        dropoffWait: ["0", Validators.required],
        dropoffLate: ["0", Validators.required],
        returnPickupEarly: ["0", Validators.required],
        returnPickupWait: ["0", Validators.required],
        returnPickupLate: ["0", Validators.required],
        maxOnBoardTime: ["0", Validators.required],
        breakCushion: [0, Validators.required],
        groupCushion: [0, Validators.required],
        groupRadius: [0, Validators.required],
        maxDistancePerRun: ["0", Validators.required],
        maxPerRun: ["0", Validators.required],
        overlapIndication: ["0", Validators.required],
        isOnboardViolation: [false, Validators.required],
        isCapacityViolation: [false, Validators.required],
        prefferedToSameDriver: [false, Validators.required],
      }),
    });

    this.getViolationData();


  }

  createViolation() {
    if (this.violationForm.invalid) return;

    this.violatioServie.saveViolation(this.violationForm.value).subscribe((data => {
      if (data) {
       sweetAlert('Success', 'Violation Updated Successfully', 'success', 'OK')
      }
    }))
  }

  getViolationData() {
    this.violatioServie.getViolationData().subscribe((data) => {
      if (data) {
        this.violationForm.patchValue({
          ...data
        })
      }
    })
  }

}
